import FormTextField from '../../2compounds/FormTextField'
import JobTitleSelect from '../../2compounds/JobTitleSelect'
import makeStyles from '@material-ui/core/styles/makeStyles'
import RecordsForm from './RecordsForm'
import PhoneField from '../../2compounds/PhoneField'
import {
    validateDescription, validateFirstName, validateJobTitle,
    validateLastName, validatePhoneNumber, validateRequiredEmail
} from '../../../services/util/editChecks'
import {Text, TextButton} from '../../1elements'
import SearchIcon from '@mui/icons-material/Search'
import OrganizationField from './OrganizationField'
import AddContactButton from '../../2compounds/AddContactButton'

const PeopleForm = ({addNewPerson, addRecord, deleteRecord, disabled, peopleData, updateRecordData, showError,
                        switchToSearch, editContactDraft, updatePerson, selectedContactType}) => {
    const classes = useStyles()
    const {firstName, lastName, jobTitle, assignedDate, phoneNumber, email, description, records, organization, organizationName} = peopleData
    const formDisabled = () => {
        return Boolean(peopleData.contactId)
    }

    return(
        <div className={classes.root}>
            <div className={classes.innerGridDiv}>
                <FormTextField label={'First Name'} hint={'Max. 45 characters'} required
                               validation={showError&&validateFirstName(firstName)} disabled={formDisabled()||disabled}
                               value={firstName} onChange={(newValue)=>editContactDraft('firstName', newValue)} />
                <FormTextField label={'Last Name'} hint={'Max. 45 characters'} required
                               validation={showError&&validateLastName(lastName)} disabled={formDisabled()||disabled}
                               value={lastName} onChange={(newValue)=>editContactDraft('lastName', newValue)} />

                {selectedContactType === 'Bee-Clean Contractor' && (
                    <OrganizationField organization={organization}
                                       setOrganization={(newValue)=>editContactDraft('organization', newValue)}
                                       organizationName={organizationName}
                                       setOrganizationName={(newValue)=>editContactDraft('organizationName', newValue)}
                                       disabled={formDisabled()||disabled}
                                       showError={showError} />
                )}


                <JobTitleSelect value={jobTitle} onChange={(newValue)=>editContactDraft('jobTitle', newValue)}
                                validation={showError&&validateJobTitle(jobTitle)} disabled={formDisabled()||disabled}/>
                <FormTextField label={'Assigned Date'} disabled value={assignedDate}
                               onChange={(newValue)=>editContactDraft('assignedDate', newValue)} />
                <PhoneField value={phoneNumber} onChange={(newValue)=>editContactDraft('phoneNumber', newValue)}
                            validation={showError&&validatePhoneNumber(phoneNumber)} disabled={formDisabled()||disabled}/>
                <FormTextField label={'Email'} value={email} onChange={(newValue)=>editContactDraft('email', newValue)}
                                validation={showError&&validateRequiredEmail(email)} disabled={formDisabled()||disabled}
                               required/>
                <FormTextField label={'Description'} hint={'Max. 255 characters'} rows={5} className={classes.description}
                               value={description} onChange={(newValue)=>editContactDraft('description', newValue)}
                               validation={showError&&validateDescription(description)} disabled={formDisabled()||disabled}/>
            </div>

            <RecordsForm value={records} setValue={editContactDraft} addRecord={addRecord} deleteRecord={deleteRecord}
                         updateRecordData={updateRecordData} showError={showError} disabled={formDisabled()||disabled}/>

            {
                !formDisabled() && (
                    <div className={classes.buttonsDiv}>
                        {peopleData.id ? (
                            <TextButton variant={'contained'} clickHandler={()=>updatePerson(peopleData.id)}>
                                Update This Contact</TextButton>
                        ):(
                            <AddContactButton onClick={addNewPerson} />
                        )}

                        <div className={classes.backToSearch} onClick={switchToSearch}>
                            <Text type={'addBuildingNameCta'}>
                                <SearchIcon /> Search from existing contacts
                            </Text>
                        </div>
                    </div>
                )
            }

        </div>
    )
}

const useStyles = makeStyles({
    root: {

    },
    innerGridDiv: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px 20px'
    },
    description: {
        gridColumn: '1/-1'
    },
    buttonsDiv: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        margin: '20px 0 20px'
    },
    backToSearch: {
        margin: '20px 0 60px',
    }
})

export default PeopleForm
